import script from "./BaseRichInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRichInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseRichInput.vue?vue&type=style&index=0&id=1f6f8e07&lang=css"

const __exports__ = script;

export default __exports__